<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header -->
    <header-component :headerTitle="headerText" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()"
      :component-name="componentsName()" />
    <v-card class="v-card-100">
      <v-card-text>
        <div class="text-left" style="margin-left:20px">
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Buyer ID</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.client_vendor_code ? item_details.client_vendor_code : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Name</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.name ? item_details.name : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Organization Name</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.organization_name ? item_details.organization_name : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Email Id</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.email ? item_details.email : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Mobile Number</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.mobile_number ? '+91 ' + item_details.mobile_number : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">WhatsApp Number</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.whats_app_number ? '+91 ' + item_details.whats_app_number : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">address</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.address ? item_details.address : '-' }}</span>
            </v-col>
          </v-row>
          <v-row v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_DETAILED_ADDRESS')">
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Pin Code</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.pin_code ? item_details.pin_code : '-' }}</span>
            </v-col>
          </v-row>
          <v-row v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_DETAILED_ADDRESS')">
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">State</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.state ? item_details.state : '-' }}</span>
            </v-col>
          </v-row>
          <v-row v-if="isConfigEnabled('LIQUIDATION_REMARKETING_BUYER_DETAILED_ADDRESS')">
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">City</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.city ? item_details.city : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
              <v-col cols="1" sm="4" md="4">
                <span class="text-align">Document Details</span>
              </v-col>

              <v-col cols="1" sm="4" md="4">
                <div v-if="item_details.business_documents && item_details.business_documents.length">
                  <div v-for="(doc, index) in item_details.business_documents" :key="index">
                    <span>
                      {{ doc.document_type }} ({{ doc.document_number }})
                      <a
                        :href="doc.document_url"
                        style="color: #1976d2; cursor: pointer; font-size: 16px;"
                        target="_blank"
                      >
                        Download {{doc.document_type }}
                      </a>
                    </span>
                  </div>
                </div>
                <div v-else>
                  <span>-</span>
                </div>
              </v-col>
            </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Preferred Category</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.category_preference ? item_details.category_preference : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Geographical Preference</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.geographical_preference ? item_details.geographical_preference : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Minimum Lot Value</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>₹{{ item_details.minimum_lot_value ? item_details.minimum_lot_value : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">maximum Lot Value</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>₹{{ item_details.maximum_lot_value ? item_details.maximum_lot_value : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Minimum Exposure Limit</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>₹{{ item_details.minimum_exposure_limit ? item_details.minimum_exposure_limit : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Maximum Exposure Limit</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>₹{{ item_details.maximum_exposure_limit ? item_details.maximum_exposure_limit : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Status</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <span>{{ item_details.buyer_status ? item_details.buyer_status : '-' }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="1" sm="4" md="4">
              <span class="text-align">Documents Uploaded</span>
            </v-col>
            <v-col cols="1" sm="4" md="4">
              <div v-if="item_details.waste_certificate_hash && item_details.waste_certificate_hash['E-Waste'] && item_details.waste_certificate_hash['E-Waste'].length">
                <div v-for="(document, index) in item_details.waste_certificate_hash['E-Waste']" :key="index">
                  <a :href="document.document_url" style="color: #1976d2; cursor: pointer;" target="_blank">{{ document.document_name }}</a>
                </div>
              </div>
              <div v-else>
                <span>-</span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  data() {
    return {
      headerText: "Manage Buyers",
      alert: false,
      alert_type: 'info',
      alert_message: '',
      item_details: '',
      buyer_code: ''
    }
  },
  components: {
    HeaderComponent
  },
  created() {
    this.fetchDetailsData()
  },
  methods: {
    isConfigEnabled(constantName) {
      const config = this.$store.state.configurations.filter(item => item.constant === constantName);
      return config.length ? config[0].is_enabled : {};
    },
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    fetchDetailsData() {
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/${this.$store.state.lotIds}`)
        .then(response => {
          if (response.data) {
            this.item_details = response.data
            this.buyer_code = this.item_details.id.toString()
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    getRouterLink() {
        if(this.$store.state.action === 'PublishDetails'){_
          return { name : this.$store.state.action }
        }else if(this.$store.state.action === 'Pending_Approval'){
          return { name : 'liquidationNew', query : { tab : 'Pending_Approval', changed : true }}
        }else if(this.$store.state.action === 'buyer_activation'){
          return { name : 'claimApproval' }
        }
        else{
          return { name: "ManageUser" };
        }      
    },
    componentsName() {
      return 'Buyer Details';
    },
    getRouterLinkText() {
      return this.$store.state.inventoryId.toString();
    },
  }
}
</script>
<style scoped>
.text-align {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #0C0C0C;
}
</style>